export default __webpack_public_path__ + "static/media/backgroundLogin.43953e2d.svg";